import api from '../api'
import { ServiceHost } from '../api/util'
import { setCookie, clearCookie, getCookie } from '../utils'
import store from '../../store'
import router from '../../router'
import Vue from 'vue'
import { readyException } from 'jquery'

const SHOPPING_CART = "_shopping_cart"

const state = {
  me: {},
  fbLoginInfo: {},
  permissionInsufficient: false,
  loadingCount: 0,
  errors: {},
  page: {},
  pages: [],
  shoppingCartProducts: getShoppingCartProducts(),
  shoppingCartProductsWithDetails: [],
}

function getShoppingCartProducts() {
  let products = []
  try {
    const shoppingCartValue = localStorage.getItem(SHOPPING_CART)
    if (shoppingCartValue) {
      products = JSON.parse(shoppingCartValue)
    }
  } catch(err) {
    console.warn(err)
  }
  return products
}

// actions
const actions = {
  onQuery(_, {query, variables}) {
    return api.query({
      query: query,
      variables: variables,
    }).then(data => {
      return data
    })
  },
  onLogin(_, {memberLoginVo}) {
    return api.query({
      query: 
      `
        mutation($input: MemberLoginVo!){
          LoginMember(input: $input){
            id
            jwt
          }
        }
      `,
      variables: {
        input: memberLoginVo,
      },
    }).then(data => {
      const loginInfo = data.LoginMember
      setCookie('_jwt', loginInfo.jwt, 30)
      let nextHref = ''
      const requestHref = getCookie('request_href')
      if (requestHref) {
        nextHref = requestHref
      } else {
        nextHref = router.resolve({
          name: '首頁',
        }).href
      }
      store.commit('page/setPermissionInsufficient', false)
      clearCookie('request_href')
      window.location.replace(nextHref)
    })
  },

  onRegister(_, {memberRegisterVo}) {
    return api.query({
      query: 
      `
        mutation($input: MemberRegisterVo!){
          RegisterMember(input: $input){
            id
            jwt
          }
        }
      `,
      variables: {
        input: memberRegisterVo,
      },
    }).then(data => {
      const loginInfo = data.RegisterMember
      setCookie('_jwt', loginInfo.jwt, 30)
      let nextHref = ''
      const requestHref = getCookie('request_href')
      if (requestHref) {
        nextHref = requestHref
      } else {
        nextHref = router.resolve({
          name: '首頁',
        }).href
      }
      store.commit('page/setPermissionInsufficient', false)
      clearCookie('request_href')
      window.location.replace(nextHref)
    })
  },

  getFBLoginURL({ commit, }) {
    return new Promise((resolutionFunc, rejectionFunc) => {
      const redirectUrl = ServiceHost + '/api/fbLogin'
      resolutionFunc(redirectUrl)
    })
  },

  onFbLoginV2({ commit, }) {
    return new Promise((resolutionFunc, rejectionFunc) => {
      try {
        const fbMeStr = getCookie('fb_me')
        if (!fbMeStr) {
          throw new Error("failed to get fb info")
        }

        const fbLoginInfo = JSON.parse(atob(fbMeStr))
        commit('set', ['fbLoginInfo', fbLoginInfo])
        clearCookie('fb_me')
        resolutionFunc(fbLoginInfo)
      } catch(err) {
        console.warn(err)
      }
    }).then(fbLoginInfo => {
      return api.query({
        query: 
        `
          mutation($id: String!){
            LoginMemberByFB(id: $id){
              id
              jwt
            }
          }
        `,
        variables: {
          id: fbLoginInfo.id,
        },
      })
    }).then(data => {
      const loginInfo = data.LoginMemberByFB
      if (!loginInfo.id) {
        router.push({ name: 'FB登入', })
      } else {
        setCookie('_jwt', loginInfo.jwt, 30)
        let nextHref = ''
        const requestHref = getCookie('request_href')
        if (requestHref) {
          nextHref = requestHref
        } else {
          nextHref = router.resolve({
            name: '首頁',
          }).href
        }
        store.commit('page/setPermissionInsufficient', false)
        clearCookie('request_href')
        window.location.replace(nextHref)
      }
    })
  },
  
  onFbLogin({ commit, }, {}) {
    return new Promise((resolutionFunc, rejectionFunc) => {
      window.FB.login(function(response) {
        if (response.authResponse) {
         window.FB.api('/me?fields=name,id,email', function(response) {
           commit('set', ['fbLoginInfo', response])
           resolutionFunc(response)
         });
        } else {
         console.error('User cancelled login or did not fully authorize.');
        }
      }, {scope: 'public_profile,email'});
    }).then(fbLoginInfo => {
      return api.query({
        query: 
        `
          mutation($id: String!){
            LoginMemberByFB(id: $id){
              id
              jwt
            }
          }
        `,
        variables: {
          id: fbLoginInfo.id,
        },
      })
    }).then(data => {
      const loginInfo = data.LoginMemberByFB
      if (!loginInfo.id) {
        router.push({ name: 'FB登入', })
      } else {
        setCookie('_jwt', loginInfo.jwt, 30)
        let nextHref = ''
        const requestHref = getCookie('request_href')
        if (requestHref) {
          nextHref = requestHref
        } else {
          nextHref = router.resolve({
            name: '首頁',
          }).href
        }
        store.commit('page/setPermissionInsufficient', false)
        clearCookie('request_href')
        window.location.replace(nextHref)
      }
    })
  },

  onFBRegister(_, { memberFBSignUpAddVo }) {
    return api.query({
      query: 
      `
        mutation($input: MemberFBSignUpAddVo!){
          RegisterMemberByFB(input: $input){
            id
            jwt
          }
        }
      `,
      variables: {
        input: memberFBSignUpAddVo,
      },
    }).then(data => {
      const loginInfo = data.RegisterMemberByFB
      setCookie('_jwt', loginInfo.jwt, 30)
      let nextHref = ''
      const requestHref = getCookie('request_href')
      if (requestHref) {
        nextHref = requestHref
      } else {
        nextHref = router.resolve({
          name: '首頁',
        }).href
      }
      store.commit('page/setPermissionInsufficient', false)
      clearCookie('request_href')
      window.location.replace(nextHref)
    })
  },

  onFbConnect({ commit, }) {
    return new Promise((resolutionFunc, rejectionFunc) => {
      window.FB.login(function(response) {
        if (response.authResponse) {
         window.FB.api('/me?fields=name,id,email', function(response) {
           commit('set', ['fbLoginInfo', response])
           resolutionFunc(response)
         });
        } else {
         console.error('User cancelled login or did not fully authorize.');
        }
      }, {scope: 'public_profile,email'});
    }).then(fbLoginInfo => {
      return api.query({
        query: 
        `
          mutation($id: String!){
            ConnectMemberFB(id: $id)
          }
        `,
        variables: {
          id: fbLoginInfo.id,
        },
      })
    }).then(() => {
      window.location.reload()
    })
  },

  addProductToShoppingCart({ state, commit }, { id, num, spec }) {
    const shoppingCartProducts = getShoppingCartProducts()
    let isNew = true
    const newShoppingCartProducts = []
    for (const shoppingCartProduct of shoppingCartProducts) {
      if (id === shoppingCartProduct.id && spec === shoppingCartProduct.spec) {
        newShoppingCartProducts.push({
          ...shoppingCartProduct,
          num: shoppingCartProduct.num + num,
          spec: spec,
        })
        isNew = false
      } else {
        newShoppingCartProducts.push(shoppingCartProduct)
      }
    }
    if (isNew) {
      newShoppingCartProducts.push({
        id: id,
        num: num,
        spec: spec,
      })
    }
    localStorage.setItem(SHOPPING_CART, JSON.stringify(newShoppingCartProducts))
    commit('set', ['shoppingCartProducts', newShoppingCartProducts])
  },

  updateShoppingCart({ state, commit }, { isDelete, id, num, spec }) {
    const shoppingCartProducts = getShoppingCartProducts().map(element => {
      return {
        ...element,
      }
    })
    let selectedItem = null
    for (const shoppingCartProduct of shoppingCartProducts) {
      if (id === shoppingCartProduct.id && spec === shoppingCartProduct.spec) {
        selectedItem = shoppingCartProduct
        break
      }
    }

    if (selectedItem) {
      const index = shoppingCartProducts.indexOf(selectedItem)
      if (isDelete) {
        shoppingCartProducts.splice(index, 1)
      } else {
        shoppingCartProducts[index] = {
          ...shoppingCartProducts[index],
          num: num,
        }
      }
    }

    localStorage.setItem(SHOPPING_CART, JSON.stringify(shoppingCartProducts))
    commit('set', ['shoppingCartProducts', shoppingCartProducts])
  },

  getShoppingCartProductsWithDetails({ state, commit }) {
    const shoppingCartProducts = getShoppingCartProducts()
    if (shoppingCartProducts.length === 0) {
      return
    }
    const productIds = []
    for (const item of shoppingCartProducts) {
      productIds.push(item.id)
    }
    return api.query({
      query: 
      `
        query($ids: [String]!) {
          ListEnabledProductsByIds(ids: $ids){
            id
            image_url
            name
            price
          }
        }
      `,
      variables: {
        ids: productIds,
      },
    }).then(data => {
      const products = data.ListEnabledProductsByIds
      const shoppingCartProductsWithDetails = []
      for (const product of products) {
        for (const item of shoppingCartProducts) {
          if (item.id === product.id) {
            shoppingCartProductsWithDetails.push({
              ...item,
              ...product,
            })
            continue
          }
        }
      }
      commit('set', ['shoppingCartProductsWithDetails', shoppingCartProductsWithDetails])
      return true
    })
  },

  logout ({ commit }) {
    clearCookie('_jwt')
    commit('set', ['me', {}])
    const url = router.resolve({
      name: '首頁',
    }).href
    window.location.replace(url)
  },

  listPages({ commit }) {
    return api.listPages()
      .then((data) => {
        commit('set', ['pages', data]) 
        return true
      })
  },

  getPage({ commit }, path) {
    return api.getPage(path)
      .then((data) => {
        commit('setPage', data) 
        return true
      })
  },

  initData({ commit, state, }) {
    return new Promise((resolutionFunc, rejectionFunc) => {
      if (state.me.id) {
        resolutionFunc(state.me)
      } else {
        api.query({
          query: `
            query{
              GetMe{
                id
                roles
              }
            }
          `,
        }).then(data => {
          commit('set', ['me', data.GetMe])
          resolutionFunc(data.GetMe)
        })
      }
    })
  }
  
}

const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  setPermissionInsufficient(state, permissionInsufficient) {
    state.permissionInsufficient = permissionInsufficient
  },
  addLoadingCount (state) {
    state.loadingCount += 1
  },
  minusLoadingCount (state) {
    state.loadingCount -= 1
  },
  setPage (state, page) {
    state.page = page
  },
  setI18nMessage (state, [i18nId, message]) {
    Vue.set(state.i18nMessage, i18nId, message)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}